// extracted by mini-css-extract-plugin
export default {"products":"vy-z","card":"wy-z","oosMessaging":"xy-z"};